import { render, staticRenderFns } from "./linkTarget.vue?vue&type=template&id=20b057c6&scoped=true"
import script from "./linkTarget.vue?vue&type=script&lang=js"
export * from "./linkTarget.vue?vue&type=script&lang=js"
import style0 from "./linkTarget.vue?vue&type=style&index=0&id=20b057c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b057c6",
  null
  
)

export default component.exports